"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenueDetailsService = void 0;
class RevenueDetailsService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get Chathost Revenue Details
     * @returns ChathostRevenueDetails Successful Response
     * @throws ApiError
     */
    chathostGetChathostRevenueDetails() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/info',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Chathost List Payments
     * @returns ChathostPayment Successful Response
     * @throws ApiError
     */
    chathostGetChathostListPayments() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/listpayments',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Chathost Payment Details
     * @param requestBody
     * @returns PaymentDetailsResponse Successful Response
     * @throws ApiError
     */
    chathostGetChathostPaymentDetails(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/revenuedetails/paymentdetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chathost Payment Detail Update
     * @returns PaymentDetails Successful Response
     * @throws ApiError
     */
    chathostGetChathostPaymentDetailUpdate() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/paymentdetailsupdate',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update Chathost Payment Detail
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpdateChathostPaymentDetail(requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/chathost/revenuedetails/paymentdetailsupdate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Chathost Payment Detail
     * @param requestBody
     * @returns PaymentDetailsCreateResponse Successful Response
     * @throws ApiError
     */
    chathostCreateChathostPaymentDetail(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/revenuedetails/paymentdetailsupdate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Chathost Payment Confirm Email Address
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpdateChathostPaymentConfirmEmailAddress(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/revenuedetails/paymentdetailsupdate/confirmemailaddress',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Chathost Payment Resend Confirmation Email Address
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpdateChathostPaymentResendConfirmationEmailAddress() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/paymentdetailsupdate/resendconfirmationemailaddress',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update Chathost Payment Resend Confirmation Email Link
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpdateChathostPaymentResendConfirmationEmailLink() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/paymentdetailsupdate/resendconfirmationemaillink',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Studio Payment History
     * @returns StudioPaymentHistory Successful Response
     * @throws ApiError
     */
    studioGetStudioPaymentHistory() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/revenuedetails/paymentdetailsupdate/paymenthistory',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Revenue Details
     * @param chathostId
     * @returns ChathostRevenueDetails Successful Response
     * @throws ApiError
     */
    studioGetRevenueDetails(chathostId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/revenuedetails/info/{chathost_id}',
            path: {
                'chathost_id': chathostId,
            },
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chathost List Payments
     * @param chathostId
     * @returns ChathostPayment Successful Response
     * @throws ApiError
     */
    studioGetChathostListPayments(chathostId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/revenuedetails/listpayments/{chathost_id}',
            path: {
                'chathost_id': chathostId,
            },
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chathost Payment Details
     * @param requestBody
     * @returns PaymentDetailsResponse Successful Response
     * @throws ApiError
     */
    studioGetChathostPaymentDetails(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/revenuedetails/paymentdetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
}
exports.RevenueDetailsService = RevenueDetailsService;
